<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="កញ្ចប់សេវាកម្មទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតកញ្ចប់សេវាកម្មថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ ឬលេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>

			<md-table v-if="packageList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>សុពលភាព</md-table-head>
					<md-table-head>ចំណាំ</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(pkg, index) in packageList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ pkg.code }}</b></md-table-cell>
					<md-table-cell><b>{{ pkg.name }}</b></md-table-cell>
					<md-table-cell>
						<b v-if="pkg.duration > 12">សុពលភាព {{ pkg.duration }} ថ្ងៃ</b>
						<b v-else>សុពលភាព {{ pkg.duration }} ខែ</b>
					</md-table-cell>
					<md-table-cell><b>{{ pkg.note }}</b></md-table-cell>
					<md-table-cell><b>{{ config.datelify(pkg.created_date) }}</b></md-table-cell>
					<md-table-cell>
						<router-link :to="'/packages/edit/' + pkg.hash">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(pkg.hash)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុបកញ្ចប់សេវាកម្មនេះ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="packageList.length == 0 && loadMore == true">មិនមានអ្នកទីផ្សារ</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីកញ្ចប់សេវាកម្ម</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះកញ្ចប់សេវាកម្ម *</label>
								<md-input type="text" v-model="package.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>សុពលភាពកញ្ចប់សេវាកម្ម *</label>
								<md-select placeholder="សុពលភាពកញ្ចប់សេវាកម្ម *" v-model="package.expiry">
									<md-option value="15">15 ថ្ងៃ</md-option>
									<md-option value="1">1 ខែ</md-option>
									<md-option value="2">2 ខែ</md-option>
									<md-option value="3">3 ខែ</md-option>
									<md-option value="4">4 ខែ</md-option>
									<md-option value="5">5 ខែ</md-option>
									<md-option value="6">6 ខែ</md-option>
									<md-option value="7">7 ខែ</md-option>
									<md-option value="8">8 ខែ</md-option>
									<md-option value="9">9 ខែ</md-option>
									<md-option value="10">10 ខែ</md-option>
									<md-option value="11">11 ខែ</md-option>
									<md-option value="12">12 ខែ</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំ</label>
								<md-input type="text" v-model="package.note"></md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះកញ្ចប់សេវាកម្ម</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(package.name).length > 0">{{package.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>សុពលភាពកញ្ចប់សេវាកម្ម</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(package.expiry).length > 0">មានសុពលភាព {{package.expiry}} ខែ</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(package.note).length > 0">{{package.note}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postPackage()">បង្កើត</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបកញ្ចប់សេវាកម្មនេះពិតមែនទេ ?"
			md-content="កញ្ចប់សេវាកម្មនេះនឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				c: '',
				search: {
					text: ""
				},
				package: {
					name: "",
					expiry: "",
					note: ""
				},
				loadMore: true,
				packageList: []

			}
		},
		methods: {
			postPackage() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/package/post", {
					package: this.package
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អ្នកផ្ញើរឥវ៉ាន់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
						this.clearAll();
					}
					// this.loadMoreCompanyButton = true

				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/package/search", {
					text: this.search.text,
					offset: more ? this.packageList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.packageList = more ? this.packageList.concat(data.body.data) : data.body.data;
					// this.referralList = data.body.data;
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/package/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "កញ្ចប់សេវាកម្មត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.dialogActive = false
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			},
			checkValidation() {
				if (String(this.package.name).length > 0 && String(this.package.expiry).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.package = {
					name: "",
					expiry: "",
					note: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Package/View.vue